export enum PredictionJobConstants {
  UntitledName = "Untitled Prediction"
}

export enum PredictionJobHelperText {
  PredictionJobNameUpdated = "Prediction job name updated successfully!"
}
